import { useState } from 'react';

const BODY_TYPE_SECTIONS = {
  female: {
    sections: [
      {
        title: 'Body Type',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbody1.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbody2.webp', label: 'Fit' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbody3.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbody4.webp', label: 'Curvy' }
        ]
      },
      {
        title: 'Breast Type',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast1.webp', label: 'Small' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast3.webp', label: 'Large' }
        ]
      },
      {
        title: 'Booty Type',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbooty2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbooty3.webp', label: 'Sporty' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbooty4.webp', label: 'Large' }
        ]
      }
    ]
  },
  creature: {
    sections: [
      {
        title: 'Skin Color',
        field: 'bodycolor',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/Fblue.webp', label: 'Blue' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/Fgreen.webp', label: 'Green' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/Fred.webp', label: 'Red' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/Fwhite.webp', label: 'White' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/Fyellow.webp', label: 'Yellow' }
        ]
      },
      {
        title: 'Characteristic Properties',
        field: 'wings',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/nowings.webp', label: 'No wings' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/wings.webp', label: 'With wings' }
        ]
      }
    ]
  },
  male: {
    sections: [
      {
        title: 'Body Type',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybody1.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybody2.webp', label: 'Muscular' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybody3.webp', label: 'Fat' }
        ]
      },
      {
        title: 'Penis Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock1.webp', label: 'Small' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock3.webp', label: 'Large' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock4.webp', label: 'Extra Large' }
        ]
      },
      {
        title: 'Chest Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboychest3.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboychest1.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboychest2.webp', label: 'Muscular' }
        ]
      },
      {
        title: 'Booty Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybooty1.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybooty3.webp', label: 'Sporty' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboybooty4.webp', label: 'Huge' }
        ]
      }
    ]
  },
  trans: {
    sections: [
      {
        title: 'Body Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbody1.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbody2.webp', label: 'Athletic' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbody3.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbody4.webp', label: 'Curvy' }
        ]
      },
      {
        title: 'Booty Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbooty1.webp', label: 'Slim' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbooty2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbooty3.webp', label: 'Sporty' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransbooty4.webp', label: 'Huge' }
        ]
      },
      {
        title: 'Breast Type',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast1.webp', label: 'Small' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirlbreast3.webp', label: 'Large' }
        ]
      },
      {
        title: 'Penis Size',
        options: [
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock1.webp', label: 'Small' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock2.webp', label: 'Medium' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock3.webp', label: 'Large' },
          { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetranscock4.webp', label: 'Extra Large' }
        ]
      }
    ]
  }
};

const HEADINGS = {
  female: 'Choose Her Body Type',
  male: 'Choose His Body Type',
  trans: 'Choose Their Body Type',
  creature: 'Choose Her Skin Color'
};

const Step3BodyType = ({ formData, updateFormData, goToStep }) => {
  const [selections, setSelections] = useState({});
  const sections = BODY_TYPE_SECTIONS[formData.gender]?.sections || [];
  const heading = HEADINGS[formData.gender] || 'Choose Body Type';

  const handleSelect = (sectionTitle, optionLabel, fieldName) => {
    const newSelections = {
      ...selections,
      [sectionTitle]: optionLabel
    };
    setSelections(newSelections);
    
    // For creature, save specific fields
    if (formData.gender === 'creature' && fieldName) {
      updateFormData(`extraFields.${fieldName}`, optionLabel);
    } else {
      // For other genders, store all selections as a combined string with labels
      const bodyTypeString = Object.entries(newSelections)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
      updateFormData('extraFields.bodyType', bodyTypeString);
    }
  };

  const allSectionsSelected = sections.every(section => selections[section.title]);

  const handleNext = () => {
    if (allSectionsSelected) {
      goToStep(4);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '100px 20px 40px',
      position: 'relative',
      overflowY: 'auto'
    }}>
      {/* Background images */}
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/s2zgc1ad_nowings.png" 
        alt="Background Left" 
        className="bg-image-left"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/h9eorbzw_female6.png" 
        alt="Background Right" 
        className="bg-image-right"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/i4w18itu_9.png" 
        alt="Background Center" 
        className="bg-image-center"
      />

      <h1 style={{
        fontSize: 'clamp(36px, 6vw, 56px)',
        marginBottom: '60px',
        letterSpacing: '4px',
        textAlign: 'center',
        color: '#DA3D57',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1
      }} data-testid="step3-heading">
        {heading}
      </h1>

      <div style={{
        width: '100%',
        maxWidth: '1400px',
        position: 'relative',
        zIndex: 1
      }}>
        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex} style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: 'clamp(24px, 3.5vw, 32px)',
              marginBottom: '20px',
              letterSpacing: '2px',
              color: '#DA3D57',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              {section.title}
            </h2>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              overflowX: 'auto',
              gap: '15px',
              padding: '10px 20px',
              scrollbarWidth: 'thin'
            }}>
              {section.options.map((option, optionIndex) => (
                <div
                  key={optionIndex}
                  style={{
                    minWidth: '120px',
                    flexShrink: 0,
                    textAlign: 'center'
                  }}
                >
                  <div
                    className={`media-item ${selections[section.title] === option.label ? 'selected' : ''}`}
                    onClick={() => handleSelect(section.title, option.label, section.field)}
                    style={{
                      width: '120px',
                      height: '170px',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      marginBottom: '8px'
                    }}
                    data-testid={`bodytype-${sectionIndex}-${optionIndex}`}
                  >
                    <img src={option.url} alt={option.label} />
                  </div>
                  <div style={{
                    fontSize: '14px',
                    color: '#DA3D57',
                    fontWeight: 'bold'
                  }}>
                    {option.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn-primary"
        onClick={handleNext}
        disabled={!allSectionsSelected}
        style={{
          marginTop: '40px',
          position: 'relative',
          zIndex: 1
        }}
        data-testid="step3-next-button"
      >
        Next
      </button>
    </div>
  );
};

export default Step3BodyType;
